(function () {
  function openDoofinder() {
    var input =
      document.querySelector('input.search__input[name="q"][type="search"]') ||
      document.querySelector('input[name="q"][type="search"]');
    if (!input) return false;

    try { input.focus({ preventScroll: true }); } catch (e) {}
    input.dispatchEvent(new MouseEvent('mousedown', { bubbles: true }));
    input.click();
    return true;
  }

  document.addEventListener(
    'click',
    function (e) {
      var opener = e.target.closest && e.target.closest('side-drawer-opener[data-side-drawer="#Drawer-Search"]');
      if (!opener) return;
      if (openDoofinder()) {
        e.preventDefault();
        e.stopImmediatePropagation();
      }
    },
    true
  );
})();
